import { connect } from 'react-redux';
import { compose } from 'recompose';
import { getFormValues } from 'redux-form';

import TimeEntryCreateEditFormWithDate, { FORM_NAME } from './TimeEntryCreateEditFormWithDate';
import { dispatchHideTimeEntryEditorModal } from '../../../timesheetApprovals/actions';
import { getUserTimeZone } from '../../../authentication/selectors';

const mapStateToProps = (state) => {
  return {
    initialValues: state.timeEntryForm.data,
    // this seems fragile but it solves the problem of the fields being
    // dependent on one another
    formValues: getFormValues(FORM_NAME)(state),
    APIErrorMessage: state.timeEntryForm.APIErrorMessage,
    timeZone: getUserTimeZone(state),
  };
};

const mapDispatchToProps = {
  dispatchHideTimeEntryEditorModal,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);


// ORDER MATTERS. If you want redux to put the props in required for queries
// you better withRedux FIRST
const enhance = compose(withRedux);

export default enhance(TimeEntryCreateEditFormWithDate);
